module.exports = __webpack_public_path__ + "img/right-voice.f799dcc4.png";